import { articleTypes } from "./options"

const getOptionName = (options, selectedType) => {
  const selectedOption = options.find((option) => option.type === selectedType)
  return selectedOption?.title
}
export const getArticleTypeName = (type) => getOptionName(articleTypes, type)
